"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DynamicSelect = ({ details, value, onChange, onBlur, id, isReadOnly, type, }) => {
    const isMultiple = type === 'enum-multiple';
    const opts = {};
    if (isReadOnly)
        opts.disabled = 'disabled';
    if (isMultiple)
        opts.multiple = true;
    return (react_1.default.createElement("select", { ...opts, onChange: onChange, onBlur: onBlur, id: id, value: isMultiple ? value.split(' ') : value }, details.map(({ value: detailValue, label: detailLabel }, i) => (react_1.default.createElement("option", { value: detailValue, key: i }, detailLabel)))));
};
exports.default = DynamicSelect;
//# sourceMappingURL=Select.js.map